<section class="content rest-configuration-page">
  <div class="content-block rest-configuration-page__content">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('restConfigurationsCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="rest-configuration-list-workspace">
      <app-master-table
        [title]="'restConfigurationsCatalog.title' | translate"
        [dataSource]="dataSource"
        [columnDefinitions]="columnDefinitions"
        [actions]="actions"
        [filters]="tableFilters"
        [isLoading]="isLoading"
        [enableRowClick]="false"
        [rowClickSelection]="true"
        [showContextMenu]="false"
        [tableMaxHeight]="'100%'"
        [exportFileName]="'rest-configurations'"
        (add)="handleAdd()"
        (refresh)="loadData()"
        (details)="handleView($event)"
        (edit)="handleEdit($event)"
        (delete)="handleDelete($event)"
        (bulkDelete)="handleBulkDelete($event)"
        (searchChange)="onSearchChange($event)"
        (filtersChange)="onFiltersChange($event)">
      </app-master-table>
    </div>
  </div>
</section>
